import { useContext } from 'react';
import RichTextContext from '../context';

const memberIcons = {
  会员1: 'https://i9.taou.com/maimai/p/28865/6_6_11XkbagC6CuAiVDK',
  会员2: 'https://i9.taou.com/maimai/p/28865/7_6_21SYSX2p55lHHsR0',
  会员3: 'https://i9.taou.com/maimai/p/28865/7_6_21SYSX2p55lHHsR0',
  会员7: 'https://i9.taou.com/maimai/p/28865/7_6_21SYSX2p55lHHsR0',
};

export const MemberCheck = (attr) => ['会员1', '会员2', '会员3', '会员7'].includes(attr?.v);

export default function Member(props) {
  const icon = memberIcons[props.v];
  const richTextContex = useContext(RichTextContext);

  return (
    <img
      src={icon}
      style={{
        display: 'inline-block',
        // 根据文本行高度自适应尺寸
        height: richTextContex.lineHeight * 0.75,
        marginLeft: 4,
      }}
    />
  );
}
